import { apiClient } from './apiClient'
import type { AuthUser } from './auth'

interface ApiResponse<T> {
  success: boolean
  data?: T
  error?: string
}

function parseError(err: unknown, fallback: string): Error {
  const ax = err as { response?: { data?: { error?: string } }; message?: string }
  return new Error(ax.response?.data?.error || ax.message || fallback)
}

export async function updateAccountName(name: string): Promise<AuthUser> {
  try {
    const res = await apiClient.patch<ApiResponse<AuthUser>>('/account/name', { name })
    if (!res.data.success || !res.data.data) {
      throw new Error(res.data.error || 'Kunne ikke opdatere navn')
    }
    return res.data.data
  } catch (e) {
    throw parseError(e, 'Kunne ikke opdatere navn')
  }
}

export async function updateAccountPassword(
  currentPassword: string,
  newPassword: string
): Promise<void> {
  try {
    await apiClient.post('/account/password', { currentPassword, newPassword })
  } catch (e) {
    throw parseError(e, 'Kunne ikke opdatere adgangskode')
  }
}

export type MailDeliveryMode = 'log' | 'smtp'

export async function requestEmailChange(
  newEmail: string,
  currentPassword: string
): Promise<MailDeliveryMode> {
  try {
    const res = await apiClient.post<
      ApiResponse<{ mailDelivery: MailDeliveryMode }>
    >('/account/email/request', { newEmail, currentPassword })
    if (!res.data.success) {
      throw new Error(res.data.error || 'Kunne ikke sende bekræftelsesmail')
    }
    return res.data.data?.mailDelivery ?? 'log'
  } catch (e) {
    throw parseError(e, 'Kunne ikke sende bekræftelsesmail')
  }
}

export async function confirmEmailChange(code: string): Promise<AuthUser> {
  try {
    const res = await apiClient.post<ApiResponse<AuthUser>>('/account/email/confirm', {
      code,
    })
    if (!res.data.success || !res.data.data) {
      throw new Error(res.data.error || 'Bekræftelse fejlede')
    }
    return res.data.data
  } catch (e) {
    throw parseError(e, 'Bekræftelse fejlede')
  }
}
